import { mergeProps as raMergeProps } from '@react-aria/utils';

/**
 * Merges multiple prop objects, chaining event handlers with matching `on*`
 * names.
 */
export function mergeProps<T extends object[]>(...args: T) {
  return raMergeProps(...(args as Record<string, unknown>[]));
}
